export default function Features() {
  const features = [
    {
      icon: 'ri-lock-password-line',
      title: 'AES-256 Encryption',
      description: 'Bank-level encryption protects your data with the same security standards used by governments and financial institutions worldwide.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your browsing activity. Your online privacy is completely protected and anonymous.'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Kill Switch',
      description: 'Automatically blocks all internet traffic if your VPN connection drops, ensuring your data never leaks accidentally.'
    },
    {
      icon: 'ri-route-line',
      title: 'Split Tunneling',
      description: 'Choose which apps use the VPN and which connect directly, giving you complete control over your network traffic.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'DNS Leak Protection',
      description: 'Prevents DNS requests from leaking outside the VPN tunnel, keeping your browsing history completely private.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Platform Support',
      description: 'Available on Windows, macOS, iOS, Android, and Linux. Protect all your devices with a single subscription.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-[#0D1B2A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <span className="text-[#00D9FF] text-sm font-semibold tracking-[0.2em] uppercase">FEATURES</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4">Military-Grade Protection</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#162032] p-8 rounded-2xl border border-[#00D9FF]/0 hover:border-[#00D9FF]/50 transition-all duration-300 hover:shadow-2xl hover:shadow-[#00D9FF]/20 group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-5xl text-[#00D9FF] group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
